import type { ExpenseCurrency } from "@/services/APIs/PtsExpenseSummaryService";

export const EXPENSE_CATEGORY_OPTIONS = [
  "AI Tools",
  "Cloud",
  "Communication",
  "Domain & Hosting",
  "Software",
  "Other",
] as const;

export const EXPENSE_FREQUENCY_OPTIONS = [
  "Monthly",
  "Quarterly",
  "Yearly",
  "One Time",
] as const;

export const EXPENSE_STATUS_OPTIONS = [
  "Active",
  "Paused",
  "Cancelled",
] as const;

/** Frequencies that repeat on a billing cycle; anything else counts as one-time. */
export const RECURRING_FREQUENCIES = new Set<string>(["monthly", "yearly"]);

export const CURRENCY_OPTIONS: {
  value: ExpenseCurrency;
  label: string;
  symbol: string;
}[] = [
  { value: "INR", label: "INR", symbol: "₹" },
  { value: "US", label: "US", symbol: "$" },
];

export const CURRENCY_SYMBOLS: Record<string, string> = {
  INR: "₹",
  US: "$",
  USD: "$",
};

export const DEFAULT_CURRENCY: ExpenseCurrency = "INR";

/**
 * Conversion rate used to express USD expenses in INR so that the summary
 * cards can add up mixed-currency rows. Update when the working rate changes.
 */
export const USD_TO_INR_RATE = 95;

export const FILTER_SELECT_CLASS =
  "w-full [&_.ant-select-selector]:!h-9 [&_.ant-select-selector]:!min-h-9 [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!rounded-lg [&_.ant-select-selector]:!border-gray-200 [&_.ant-select-selector]:!bg-[#fafafa] [&_.ant-select-selector]:!px-3 [&_.ant-select-selection-item]:!leading-7 [&_.ant-select-selection-placeholder]:!leading-7";

export interface ExpenseFilterValues {
  category: string | undefined;
  frequency: string | undefined;
  status: string | undefined;
  search: string;
}

export const EMPTY_EXPENSE_FILTERS: ExpenseFilterValues = {
  category: undefined,
  frequency: undefined,
  status: undefined,
  search: "",
};
